module.exports = __webpack_public_path__ + "static/img/qnset6.07b3956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnset6.png
// module id = 360
// module chunks = 0